import { TopBar } from '@/layouts/TopBar';
import Paths from '@/routes/paths';
import FormStepperHeader from '@atoms/FormStepperHeader';
import { JButton } from '@atoms/JButton';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FormContainerStyled } from './form-create-top-ups.styled';
import TopUpsFormDetails from '../../molecules/TopUpsFormDetails';
import useTopUpsMutationContext from '@/modules/credits/hooks/useTopUpsMutationContext';
import TopUpsFormRepartition from '../../molecules/TopUpsFormRepartition';
import useJDialog from '@/hooks/useJDialog';
import ConfirmCancelPopUps from '../../molecules/ConfirmCancelPopUps';

const TopUpsForm = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { showJDialog, closeJDialog } = useJDialog();

  const { stepIndex, setStepIndex, mode } = useTopUpsMutationContext();

  const onClickCancel = () => {
    showJDialog(
      t('CANCEL_POP_UPS'),
      <ConfirmCancelPopUps
        onCancel={() => {
          navigate(Paths.CreditsPage);
          closeJDialog();
        }}
        onClose={closeJDialog}
      />,
    );
  };
  return (
    <>
      <TopBar title={t('NEW_TOP_UPS')}>
        <JButton onClick={onClickCancel} variant="text">
          {t('CANCEL')}
        </JButton>
      </TopBar>
      <FormContainerStyled>
        <FormStepperHeader
          onChangeStep={(value) => setStepIndex(value)}
          clickable={mode === 'edit'}
          titles={['DETAILS', 'DISTRIBUTION']}
          stepIndex={stepIndex}
        />

        {stepIndex === 0 && <TopUpsFormDetails />}
        {stepIndex === 1 && <TopUpsFormRepartition />}
      </FormContainerStyled>
    </>
  );
};

export default TopUpsForm;
